import React from 'react';
import { useSelector } from 'react-redux';

import { formatParsedDate } from 'utils';

import Icon from 'components/commons/Icon';

import { FormattedMessage } from 'react-intl';
import {
  Wrapper,
  Title,
  NewsWrapper,
  NewsItem,
  NewsUpdate,
  NewsText,
} from './styles';

const CompaniesNews = () => {
  const news = useSelector(state => state.currency.companiesNewsList);
  const newsItems = Array.isArray(news?.data) ? news.data : [];

  if (newsItems.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <Title title="companies.news.mainTi">
        <FormattedMessage id="companies.news.mainTitle" />
      </Title>

      <NewsWrapper>
        {newsItems.map(el => (
          <NewsItem key={el.id} href={el.link}>
            <NewsUpdate>
              {formatParsedDate(el.date, 'DD MMMM YYYY hh:mm')}
              {` `}

              <Icon name="newsCompanyIcon" />
            </NewsUpdate>

            <NewsText>{el.title}</NewsText>
          </NewsItem>
        ))}
      </NewsWrapper>
    </Wrapper>
  );
};

export default React.memo(CompaniesNews);
